import { createSlice } from '@reduxjs/toolkit';
import {
  adminApproveArticleSuggestion,
  adminRejectArticleSuggestion,
  getAdminArticleSuggestionList,
  getAdminArticleSuggestionPendingCount,
} from '../actions/adminArticleSuggestionActions';
import { getPageFromUrl } from '../../../utils/paginationUtil';

const initialState: AdminArticleSuggestionStateType = {
  suggestions: [],
  isLoading: false,
  errorMessage: '',
  pendingCount: 0,
  paginator: { count: 0, next: null, previous: null, currentPage: 1, pageSize: 12 },
};

const adminArticleSuggestionSlice = createSlice({
  name: 'adminArticleSuggestions',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getAdminArticleSuggestionList.pending, state => {
      state.isLoading = true;
      state.errorMessage = '';
    });
    builder.addCase(getAdminArticleSuggestionList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.suggestions = action.payload.results;
      state.paginator = {
        count: action.payload.count,
        next: getPageFromUrl(action.payload.next),
        previous: getPageFromUrl(action.payload.previous),
        currentPage: action.meta.arg.page ?? 1,
        pageSize: action.payload.page_size,
      };
    });
    builder.addCase(getAdminArticleSuggestionList.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload?.detail || 'Failed to load article suggestions.';
    });

    builder.addCase(getAdminArticleSuggestionPendingCount.fulfilled, (state, action) => {
      state.pendingCount = action.payload.pending_count;
    });

    builder.addCase(adminApproveArticleSuggestion.fulfilled, (state, action) => {
      const updated = action.payload;
      const idx = state.suggestions.findIndex(s => s.id === updated.id);
      const wasPending = idx === -1 || state.suggestions[idx].status === 'pending';
      if (idx !== -1) state.suggestions[idx] = updated;
      if (wasPending) state.pendingCount = Math.max(0, state.pendingCount - 1);
    });
    builder.addCase(adminApproveArticleSuggestion.rejected, (state, action) => {
      state.errorMessage = action.payload?.detail || 'Failed to approve suggestion.';
    });

    builder.addCase(adminRejectArticleSuggestion.fulfilled, (state, action) => {
      const updated = action.payload;
      const idx = state.suggestions.findIndex(s => s.id === updated.id);
      const wasPending = idx === -1 || state.suggestions[idx].status === 'pending';
      if (idx !== -1) state.suggestions[idx] = updated;
      if (wasPending) state.pendingCount = Math.max(0, state.pendingCount - 1);
    });
    builder.addCase(adminRejectArticleSuggestion.rejected, (state, action) => {
      state.errorMessage = action.payload?.detail || 'Failed to reject suggestion.';
    });
  },
});

export default adminArticleSuggestionSlice.reducer;
